import { Component } from 'react';
import { Button, Card, Form, Image, InputGroup, Spinner, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { DarkElectricBlue, GammaBlue, White } from '../../helpers/brand_colors_helper';
import { t } from '../../helpers/translation_helper';
import { GET, POST } from '../../api';
import { getUrlParam } from '../../helpers/general_helpers';
import GetIcon from '../../helpers/icon_helper';

//const apiURL = process.env.REACT_APP_API_URL;
//const processPaymentURL = 'payment-gateway-mastercard/process-payment';
const createSessionURL = 'payment-gateway-mastercard/create-session';

class PaymentGatewayMastercard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      creatingSession: false,
      sessionReady: false,
      verifying: false,
      paymentStatusResult: null,
      session: null,
      merchantId: null,
      apiBaseUrl: null,
      countries: [],
      balance: 0,
      formCheckOut: {
        country: '',
        firstName: '',
        lastName: '',
        email: '',
        street1: '',
        state: '',
        postcode: '',
      },
    };
    this.sessionScriptEl = null;
  }

  componentDidMount() {
    if (this.props.params) {
      this.setState({
        balance: this.props.params.balance,
        formCheckOut: {
          country:
            this.props.params.country_name || this.props.params.country_iso2
              ? {
                country_id: this.props.params.country_id,
                country_name: this.props.params.country_name,
                country_iso2: this.props.params.country_iso2,
                label: (this.props.params.country_name || '') + (this.props.params.country_iso2 ? ' (' + this.props.params.country_iso2 + ')' : ''),
                value: this.props.params.country_iso2 || '',
              }
              : '',
          firstName: this.props.params.parent_name || '',
          lastName: this.props.params.parent_name || '',
          email: this.props.params.email || this.props.params.email1 || '',
          street1: this.props.params.address || '',
          state: '',
          postcode: '',
        },
      });
    }

    const urlParams = getUrlParam();
    const orderId = urlParams.orderId || urlParams.order_id || urlParams.id;
    if (orderId) {
      this.verifyPayment(orderId, urlParams);
    }

    this.getCountries();
  }

  componentWillUnmount() {
    if (this.sessionScriptEl && this.sessionScriptEl.parentNode) {
      this.sessionScriptEl.parentNode.removeChild(this.sessionScriptEl);
    }
    if (window.PaymentSession) {
      delete window.PaymentSession;
    }
  }

  verifyPayment = async (orderId, urlParams) => {
    this.setState({ processing: true, verifying: true });
    try {
      const res = await GET('payment-gateway-mastercard/verify-payment', {
        params: {
          orderId,
          center_id: urlParams.center_id || this.props.params?.center_id,
          user_id: urlParams.user_id || this.props.params?.user_id,
          child_id: urlParams.child_id || this.props.params?.child_id,
          parent_id: urlParams.parent_id || this.props.params?.parent_id,
          actionType: urlParams.actionType || this.props.params?.actionType,
          addservicesheader_id: urlParams.addservicesheader_id || this.props.params?.addservicesheader_id,
          tenant_id: this.props.tenant_id,
        }
      });
      const resData = res ? res.data : null;
      if (resData) {
        this.setState({ paymentStatusResult: resData, processing: false, verifying: false });
      } else {
        toast.error(t('Could not verify payment status.'));
        this.setState({ processing: false, verifying: false });
      }
    } catch (err) {
      toast.error(t('Could not verify payment status.'));
      this.setState({ processing: false, verifying: false });
    }
  };

  getCountries = async () => {
    try {
      const res = await GET('payment-gateway/get-countries');
      if (res && res.data) {
        const countries = res.data.map((countryData) => {
          countryData.label = countryData.name_en + ' (' + countryData.iso2 + ')';
          countryData.value = countryData.iso2;
          return countryData;
        });
        this.setState({ countries });
      }
    } catch (err) {
      toast.error(t('Something went wrong while fetching countries'));
    }
  };

  // Requesting session ID from Mastercard Gateway
  createSession = async (balance) => {
    const amountToPay = balance || this.state.balance || this.props.params?.balance;
    const { formCheckOut } = this.state;

    if (!formCheckOut.email) {
      toast.error(t('Email is required!'));
      this.setState({ processing: false, creatingSession: false });
      return;
    } else if (!amountToPay) {
      toast.error(t('Amount is required!'));
      this.setState({ processing: false, creatingSession: false });
      return;
    } else if (!formCheckOut.firstName) {
      toast.error(t('First Name is required!'));
      this.setState({ processing: false, creatingSession: false });
      return;
    } else if (!formCheckOut.lastName) {
      toast.error(t('Last Name is required!'));
      this.setState({ processing: false, creatingSession: false });
      return;
    }

    this.setState({ creatingSession: true, processing: true, sessionReady: false, session: null });

    try {
      const checkoutData = {
        ...formCheckOut,
        country: formCheckOut.country?.value || formCheckOut.country || '',
      };

      const fData = new FormData();
      fData.append('amount', amountToPay);
      fData.append('data', JSON.stringify(checkoutData));

      const paramsToSend = {
        tenant_id: this.props.tenant_id,
        center_id: this.props.params?.center_id,
        parent_id: this.props.params?.parent_id,
        child_id: this.props.params?.child_id,
        user_id: this.props.params?.user_id,
        actionType: this.props.params?.actionType,
        addservicesheader_id: this.props.params?.addservicesheader_id,
        appname: process.env.REACT_APP_NAME,
      };

      const res = await POST(createSessionURL, fData, { params: paramsToSend });
      const resData = res ? res.data : null;

      if (!resData || !resData.type) {
        toast.error(resData?.message || t('Could not initialize session.'));
        this.setState({ creatingSession: false, processing: false });
        return;
      }

      if (resData.message) {
        toast.success(resData.message);
      }

      const redirectUrl = resData.redirect_url || resData.data?.redirect_url;
      if (redirectUrl) {
        window.location.href = redirectUrl;
        return;
      }

      const { session } = resData.data || {};
      const sessionId = session?.id || session;
      if (sessionId) {
        this.setState({ session: sessionId }, () => {
          this.loadCheckoutScript(sessionId);
        });
      } else {
        this.setState({ creatingSession: false, processing: false });
      }
    } catch (err) {
      toast.error(t('Could not start the payment form. Please refresh and try again.'));
      this.setState({ creatingSession: false, processing: false });
    }
  };

  loadCheckoutScript = (sessionId) => {
    if (this.sessionScriptEl && this.sessionScriptEl.parentNode) {
      this.sessionScriptEl.parentNode.removeChild(this.sessionScriptEl);
    }

    window.errorCallback = (error) => {
      console.error('Mastercard Checkout Error:', JSON.stringify(error, null, 2));
      const explanation = error?.cause || error?.explanation || error?.result || t('Payment error encountered.');
      toast.error(typeof explanation === 'string' ? explanation : t('Payment error encountered.'));
      this.setState({ processing: false, creatingSession: false });
    };

    window.cancelCallback = () => {
      toast.info(t('Payment process was cancelled.'));
      this.setState({ processing: false, creatingSession: false, sessionReady: false });
    };

    const script = document.createElement('script');
    script.src = 'https://ksa.gateway.mastercard.com/static/checkout/checkout.min.js';
    script.async = true;
    script.setAttribute('data-error', 'errorCallback');
    script.setAttribute('data-cancel', 'cancelCallback');

    script.onload = () => {
      if (window.Checkout) {
        window.Checkout.configure({
          session: {
            id: sessionId
          }
        });
        this.setState({ sessionReady: true, creatingSession: false, processing: false }, () => {
          setTimeout(() => {
            if (window.Checkout && typeof window.Checkout.showEmbeddedPage === 'function') {
              window.Checkout.showEmbeddedPage('#embed-target');
            }
          }, 300);
        });
      } else {
        toast.error(t('Mastercard Checkout library failed to initialize.'));
        this.setState({ creatingSession: false, processing: false });
      }
    };

    script.onerror = () => {
      toast.error(t('Could not load the secure payment gateway script.'));
      this.setState({ creatingSession: false, processing: false });
    };

    document.body.appendChild(script);
    this.sessionScriptEl = script;
  };

  submitPayment = async (e) => {
    if (e) e.preventDefault();
    const { processing, creatingSession } = this.state;
    if (processing || creatingSession) return;

    await this.createSession(this.state.balance || this.props.params?.balance);
  };

  render() {
    const { params } = this.props;
    const { countries, formCheckOut, creatingSession, processing, sessionReady, verifying, paymentStatusResult } = this.state;
    const busy = creatingSession || processing;

    if (verifying) {
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Body className="text-center p-5">
            <Spinner animation="grow" variant="dark" className="mb-3" />
            <div style={{ color: DarkElectricBlue, fontSize: 18, fontWeight: 600 }}>
              {t('Verifying payment status, please wait...')}
            </div>
          </Card.Body>
        </Card>
      );
    }

    if (paymentStatusResult) {
      const isSuccess = paymentStatusResult.type;
      const resData = paymentStatusResult.data || {};
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
            <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
              {t(paymentStatusResult.messageTitle || 'Payment Status')}
            </div>
          </Card.Header>
          <Card.Body className="text-center">
            <div className="my-3">
              <GetIcon
                icon={isSuccess ? 'LuBadgeCheck' : 'LuBadgeAlert'}
                style={{ fontSize: 60, color: isSuccess ? '#28a745' : '#dc3545' }}
              />
            </div>
            <h5 className="mb-3" style={{ color: isSuccess ? '#28a745' : '#dc3545', fontWeight: 600 }}>
              {t(paymentStatusResult.message)}
            </h5>
            <Table borderless striped className="text-start mt-4">
              <tbody>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Order ID</th>
                  <td style={{ textAlign: 'left' }}>{resData.orderId || '-'}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Amount</th>
                  <td style={{ textAlign: 'left' }}>{(resData.amount || '-') + ' ' + (resData.currency || 'SAR')}</td>
                </tr>
                <tr>
                  <th style={{ width: '50%', textAlign: 'center' }}>Status</th>
                  <td style={{ textAlign: 'left' }}>
                    <span className={`badge ${isSuccess ? 'bg-success' : 'bg-danger'}`}>
                      {resData.status || (isSuccess ? 'SUCCESS' : 'FAILED')}
                    </span>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
          <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
            <Button
              variant={isSuccess ? 'success' : 'primary'}
              style={{ width: '100%' }}
              onClick={() => {
                window.location.href = isSuccess ? window.location.origin : window.location.origin + window.location.pathname;
              }}
            >
              {isSuccess ? t('Done') : t('Try Again')}
            </Button>
          </Card.Footer>
        </Card>
      );
    }

    if (sessionReady) {
      return (
        <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
          <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
            <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>
              {t('Complete Payment')}
            </div>
          </Card.Header>
          <Card.Body>
            <div id="embed-target" style={{ minHeight: '350px' }}></div>
          </Card.Body>
        </Card>
      );
    }

    return (
      <Card className="border-0" style={{ borderRadius: '20px', marginTop: 30, marginBottom: 30, width: '90%' }}>
        <Card.Header style={{ backgroundColor: White, borderTopLeftRadius: '20px', borderTopRightRadius: '20px' }}>
          <div style={{ color: DarkElectricBlue, textAlign: 'center', fontSize: 20, fontWeight: 600 }}>Payment</div>
        </Card.Header>
        <Card.Body>
          <Table borderless striped>
            <thead>
              <tr>
                <th style={{ fontSize: 16, textAlign: 'center', color: DarkElectricBlue }} colSpan={2}>
                  Summary
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>Parent Name</th>
                <td style={{ textAlign: 'left' }}>{params?.parent_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>Student Name</th>
                <td style={{ textAlign: 'left' }}>{params?.child_name}</td>
              </tr>
              <tr>
                <th style={{ textAlign: 'center', width: '50%' }}>Amount Due</th>
                <td style={{ textAlign: 'left' }}>{params?.balance + ' ' + params?.currencycode}</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={2} style={{ textAlign: 'center' }}>
                  <div className="d-flex flex-row align-items-center justify-content-center">
                    <Image src={require('../../assets/payment-methods/american-express.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/mada.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/mastercard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                    <Image src={require('../../assets/payment-methods/visacard.png')} style={{ height: 50, marginLeft: 5, marginRight: 5 }} />
                  </div>
                </td>
              </tr>
            </tfoot>
          </Table>

          <Table borderless striped>
            <tbody>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('First Name')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.firstName}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, firstName: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Last Name')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.lastName}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, lastName: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Email')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.email}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, email: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Country')}</InputGroup.Text>
                    <div style={{ flex: 1 }}>
                      <Select
                        placeholder={t('Country')}
                        classNamePrefix="custom-styled-select"
                        options={countries}
                        onChange={(event) => this.setState({ formCheckOut: { ...formCheckOut, country: event } })}
                        value={formCheckOut.country}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999 }) }}
                      />
                    </div>
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Street')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.street1}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, street1: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('State')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.state}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, state: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
              <tr>
                <td>
                  <InputGroup>
                    <InputGroup.Text style={{ width: 120 }}>{t('Post Code')}</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={formCheckOut.postcode}
                      onChange={(e) => this.setState({ formCheckOut: { ...formCheckOut, postcode: e.target.value } })}
                    />
                  </InputGroup>
                </td>
              </tr>
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer style={{ backgroundColor: White, borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px' }}>
          <Form onSubmit={this.submitPayment}>
            <Button variant="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
              <div className="d-flex flex-row justify-content-center align-items-center">
                {busy && <Spinner animation="grow" variant="dark" className="mx-1" />}
                <div className="mx-1">{t('Pay Now')}</div>
                <div className="mx-1" style={{ fontWeight: 600 }}>{params?.currencycode}</div>
                <div className="mx-1 px-2" style={{ backgroundColor: White, borderRadius: 20, color: GammaBlue, fontWeight: 600 }}>
                  {params?.balance}
                </div>
              </div>
            </Button>
          </Form>
        </Card.Footer>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  langLabels: state.language.langLabels,
});

const mapDispatchToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps())(PaymentGatewayMastercard);